// extracted by mini-css-extract-plugin
export default {"logo":"EI624BI2L6YATtWvCzjW"};